import { useTranslation } from 'react-i18next'
import Header from '@/components/layout/header'
import Footer from '@/components/layout/footer'
import Hero from '@/components/sections/hero'
import ValueProposition from '@/components/sections/value-proposition'
import Services from '@/components/sections/services'
import Cases from '@/components/sections/cases'
import Platform from '@/components/sections/platform'
import Trust from '@/components/sections/trust'
import Insights from '@/components/sections/insights'
import Cta from '@/components/sections/cta'
import Seo from '@/components/seo/seo'
import { organizationSchema, websiteSchema, serviceSchema } from '@/components/seo/json-ld'
import { resolveLang } from '@/lib/site'

export default function Home() {
  const { t, i18n } = useTranslation()
  const lang = resolveLang(i18n.resolvedLanguage)

  const services = ['Assessment', 'Build', 'Operate'].map((name, i) =>
    serviceSchema(lang, {
      name,
      description: t(`services.items.${i}.description`) as string,
      path: '/roadmap',
    }),
  )

  return (
    <>
      <Seo
        title={t('seo.home.title') as string}
        description={t('seo.home.description') as string}
        path="/"
        jsonLd={[organizationSchema(lang), websiteSchema(lang), ...services]}
      />
      <Header />
      <main>
        <Hero />
        {/* <LogoStrip /> */}
        <ValueProposition />
        <Services />
        <Cases />
        <Platform />
        <Trust />
        <Insights />
        <Cta />
      </main>
      <Footer />
    </>
  )
}
